import { Injectable } from '@angular/core';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@Injectable()

export class CalendarTodayService {

  currentDate: Date = this.create();

  create() {
    // get appointment type of current calendar
    let root = document.querySelector('.acuity-scheduling-angular-app-root');
    if ( root !== null ) {
        window['ngRoot'] = root;
        window['appointmentType'] = window['ngRoot'].getAttribute('data-apt');
    }
    // check for reschedule or not
    let cookieDate = '';
    if ( CookieService.prototype.get('currentAPT') === window['appointmentType'] ) {
        cookieDate = CookieService.prototype.get('appointmentDate');
    }
    if (cookieDate !== undefined && cookieDate !== '') {
        return new Date(cookieDate.replace(/..$/, ':00'));
    } else {
        return new Date();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/Services/calendar-today/calendar-today.service.ts